<mat-stepper labelPosition="bottom" linear #stepper>
    <mat-step *ngFor="let item of titleStepper" completed="false">
        <ng-template matStepLabel>{{ item.title | translate }}</ng-template>
    </mat-step>
</mat-stepper>
